import React, { ComponentProps, forwardRef, ReactNode } from 'react';
import InputBlock from '../connectedForm/InputBlock';
import InputLabel from '../connectedForm/InputLabel';
import InputGroup from '../connectedForm/InputGroup';
import { Switch, Tooltip } from '@fluentui/react-components';
import HintIcon from '../connectedForm/HintIcon';

const TooltipIfRequired = ({
  children,
  hint,
  ...tooltipProps
}: { children: ReactNode; hint?: string } & Partial<ComponentProps<typeof Tooltip>>) => {
  if (hint) {
    return (
      <Tooltip content={hint} relationship="label" {...tooltipProps}>
        {children}
      </Tooltip>
    );
  }
  return children;
};

export default forwardRef(
  (
    {
      labelStyle,
      labelCols,
      inputCols,
      label,
      hint,
      ...switchProps
    }: {
      labelStyle?: 'p4' | 'fluent'; //Default if unset is 'p4'
      labelCols?: number;
      inputCols?: number;
      label: string;
      hint?: string;
    } & ComponentProps<typeof Switch>,
    ref: any
  ) => {
    const labelWithIcon = hint ? (
      <span>
        {label} <HintIcon hint={hint} />
      </span>
    ) : null;

    if (labelStyle === 'p4') {
      //TODO - Additional work required for this to be production-ready - This is a placeholder.
      //     - (The only current use of FluentSwitch is in DocumentCarousel which does not use the P4 standard layout for the switches).
      return (
        <InputBlock>
          <InputLabel label={label} cols={labelCols || 1 / 3} styles={{ label: { verticalAlign: 'middle' } }} />
          <InputGroup flexBox={flexBox} cols={inputCols || 2 / 3} withLabel={!!label}>
            <TooltipIfRequired hint={hint}>
              <Switch ref={ref} {...switchProps} label={labelWithIcon} />
            </TooltipIfRequired>
          </InputGroup>
        </InputBlock>
      );
    }

    return (
      <TooltipIfRequired hint={hint} positioning={'before'}>
        <div>
          <Switch ref={ref} {...switchProps} label={labelWithIcon} />
        </div>
      </TooltipIfRequired>
    );
  }
);
